"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidPercentValue = isValidPercentValue;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _RuleEditorNumber = _interopRequireDefault(require("../../rule-editor/atoms/RuleEditorNumber"));

var RuleEditorPercentage = function RuleEditorPercentage(_ref) {
  var atom = _ref.atom,
      value = _ref.value,
      _setValue = _ref.setValue;
  return /*#__PURE__*/_react.default.createElement(_RuleEditorNumber.default, {
    atom: atom,
    value: parseFloat((value * 100).toFixed(4)),
    setValue: function setValue(newValue) {
      return _setValue(newValue / 100);
    },
    addonAfter: "%"
  });
};

var _default = RuleEditorPercentage;
exports.default = _default;

function isValidPercentValue(atom) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      value = _ref2.value;

  return atom.type === "percentage" && typeof value === "number" && isFinite(value);
}